import { render } from "./NavigationPanel.vue?vue&type=template&id=49ac196f"
import script from "./NavigationPanel.vue?vue&type=script&lang=js"
export * from "./NavigationPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__